<template>
  <div>
    <div v-for="(item, index) in dataList" :key="item.id + index">
      <div class="wrap-style">
        <table border="1" class="table-style" width="100%">
          <tr>
            <td class="tac print-title" colspan="6">{{ item.title }}领料单</td>
          </tr>
          <tr>
            <td class="tac table-title">领料人</td>
            <td class="tac">{{ item.lxr }}</td>
            <td class="tac table-title">生产序号</td>
            <td class="tac" colspan="3">{{ item.scxh }}</td>
          </tr>
          <tr>
            <td class="tac table-title">领料部门</td>
            <td class="tac">{{ item.llbm }}</td>
            <td class="tac table-title">计划单号</td>
            <td class="tac" colspan="3">{{ item.orderNo }}</td>
          </tr>
          <tr>
            <td class="tac table-title">工单号</td>
            <td class="tac">{{ item.wipEntityName }}</td>
            <td class="tac table-title">成品物料名称</td>
            <td class="tac" colspan="3">{{ item.itemName }}</td>
          </tr>
          <tr>
            <td class="tac table-title">单据编号</td>
            <td class="tac">{{ item.dispatchNumber }}</td>
            <td class="tac table-title">工单总数量</td>
            <td class="tac" colspan="3">{{ item.planQuantity }}</td>
          </tr>
          <tr>
            <td class="tac table-title">成品规格描述</td>
            <td class="tac" colspan="5">{{ item.specification }}</td>
          </tr>
          <tr>
            <td class="tac table-title">物料编码</td>
            <td class="tac table-title">物料名称</td>
            <td class="tac table-title">派工数量（套）</td>
            <td class="tac table-title">定量（米/平方英寸）</td>
            <td class="tac table-title">合计</td>
            <td class="tac table-title">领料数量</td>
          </tr>
          <tr v-if="item.materialItemList.length===0">
            <td class="tac" colspan="6">空</td>
          </tr>
          <tr v-for="(material, materialIndex) in item.materialItemList" :key="material.itemCode + materialIndex">
            <td class="tac" width="15%">{{ material.itemCode }}</td>
            <td class="tac" width="34%">{{ material.itemName }}</td>
            <td class="tac" width="15%">{{ material.planQuantity }}</td>
            <td class="tac" width="11%">{{ material.quantityPerAssembly }}</td>
            <td class="tac" width="11%">{{ material.hj }}</td>
            <td class="tac" width="14%">{{ material.llsl }}</td>
          </tr>
          <tr>
            <td class="tac table-title">备注</td>
            <td class="tac" colspan="5">
              <div style="min-height: 48px;text-align: left">{{ item.remark }}</div>
            </td>
          </tr>
          <tr>
            <td class="tac table-title">退料</td>
            <td class="tac">{{ item.tbl }}</td>
            <td class="tac table-title">真皮批次</td>
            <td class="tac" colspan="3">{{ item.zppc }}</td>
          </tr>
          <tr>
            <td class="tac table-title">实际用量</td>
            <td class="tac">{{ item.sjyl }}</td>
            <td class="tac table-title">仿皮批次</td>
            <td class="tac" colspan="3">{{ item.fppc }}</td>
          </tr>
          <tr>
            <td class="tac table-title">计划生产时间</td>
            <td class="tac">{{ item.planProductDate }}</td>
            <td class="tac table-title">工单交期</td>
            <td class="tac">{{ item.assessmentDeliveryDate }}</td>
            <td class="tac table-title">完工时间</td>
            <td class="tac">{{ item.endTime }}</td>
          </tr>
          <tr>
            <td class="tac table-title" colspan="6">
              <div class="info">
                <div class="item">仓库主管:</div>
                <div class="item">车间主管:</div>
                <div class="item">收货人:</div>
              </div>
            </td>
          </tr>
        </table>
<!--        <div class="tip">-->
<!--          注：除实发数量和签名以外，涂改无效-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrintPickMaterial',
  data () {
    return {
      dataList: []
    }
  },
  methods: {
    show(dataList) {
      this.dataList = dataList
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="less" scoped>
.wrap-style{
  font-family: "黑体", "微软雅黑", "宋体", serif;
  color: #000;
  page-break-after: always;
  padding: 10px;
  font-size: 15px;
  table{
    border: 2px solid #000;
  }
}
.info{
  display: flex;
  justify-content: space-between;
  .item{
    text-align: left;
    padding-left: 4.2%;
    width: 33%;
  }
}
.print-title{
  font-weight: 600;
  font-size: 16px;
}
.table-title{
  font-weight: 600;
  font-size: 15px;
}
.table-style{
  width: 100%;
}
.tac{
  text-align: center;
}
tr{
  height: 30px;
}
td{
  padding: 0 5px;
}
.tip{
  margin-top: 10px;
}
</style>
